import { useCallback } from "react";
import { useEventDispatchPiloteMutation } from "../../../features/api/apiSlice";
import { FormEventDispatchPilotePostValues } from "../../../types/events";
import { SubmitHandler } from "react-hook-form";
import { FormDefinePiloteSchema } from "./FormDefinePilote";
import { isDev } from "../../../utils/dev";
import { notification } from "antd";
import { getErrorMessage } from "../../../utils/errors/errors";

type Options = {
  eventId: number;
  hideModal: () => void;
  refetchEvent: () => void;
};
export default function useSubmit({
  eventId,
  hideModal,
  refetchEvent,
}: Options) {
  const [dispatchPilote, { isLoading }] = useEventDispatchPiloteMutation();

  const _dispatchPilote: SubmitHandler<FormDefinePiloteSchema> = useCallback(
    async (values) => {
      try {
        const formattedValues: FormEventDispatchPilotePostValues = {
          pilotes: [Number(values.pilote)],
          theme: Number(values.theme),
          gravity: Number(values.gravity),
          dateAsked: values.dateAsked.toISOString(),
          needsCauseAnalysis: values.needsCauseAnalysis,
          needsActions: values.needsActions,
        };

        if (isDev) {
          console.log("formattedValues");
          console.log(formattedValues);
        }

        await dispatchPilote({ eventId, values: formattedValues }).unwrap();

        notification.success({
          message: "Le pilote a Ã©tÃ© assignÃ© avec succÃ¨s",
        });

        hideModal();
        refetchEvent();
      } catch (error) {
        console.error("Dispatch pilote", error);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [dispatchPilote, eventId, hideModal, refetchEvent],
  );

  return {
    dispatchPilote: _dispatchPilote,
    isLoading,
  };
}
